import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isUnderpaid)
    ? (_openBlock(), _createBlock("img", {
        key: 0,
        src: `@/app/ui/assets/svg/sti-reverse-scan/icon-scan-failed-underpaid${_ctx.isAccountForeign ? '-en' : ''}.svg`,
        alt: "icon-scan-failed",
        width: "388",
        height: "140"
      }, null, 8, ["src"]))
    : (_openBlock(), _createBlock("img", {
        key: 1,
        src: _ctx.failedIcon,
        alt: "icon-scan-failed",
        width: "388",
        height: "140"
      }, null, 8, ["src"]))
}